import { REHYDRATE } from 'redux-persist';
import { DEMO_MODAL_NOTIFICATIONS, FORCE_SHOW_MODAL_NOTIFICATIONS, } from 'config/debug';
import * as types from '../actions/types';
const withFallbackFlags = (featureFlags) => ({
    ...featureFlags,
    subscription_via_stripe_android: featureFlags?.subscription_via_stripe_android ?? { value: 'yes' },
    subscription_via_stripe_ios: featureFlags?.subscription_via_stripe_ios ?? {
        value: 'yes',
    },
    subscription_via_stripe_card_fallback: featureFlags?.subscription_via_stripe_card_fallback ?? { value: 'yes' },
});
export const initialState = {
    featureFlags: {},
    commonFlags: {},
    netScoreShow: null,
    scrambled: false,
    currentScreen: '',
    modalNotifications: [],
    colorScheme: undefined, // set in user preferences
};
const utils = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const utils = action.payload?.utils;
            if (utils) {
                return {
                    ...initialState,
                    ...utils,
                    scrambled: false,
                    currentScreen: null,
                    previousScreen: undefined,
                    colorScheme: utils.colorScheme ?? undefined,
                    failedToNavigateToScreen: undefined,
                };
            }
            return state;
        }
        case types.GET_FEATURE_FLAGS_SUCCESS: {
            return { ...state, featureFlags: action.payload };
        }
        case types.GET_FEATURE_FLAGS_FAILURE: {
            const featureFlags = withFallbackFlags(state.featureFlags);
            return { ...state, featureFlags };
        }
        case types.GET_COMMON_FLAGS_SUCCESS:
            return {
                ...state,
                commonFlags: action.payload,
            };
        case types.SET_SCRAMBLED:
            return { ...state, scrambled: action.payload };
        case types.SET_CURRENT_ROUTE_NAME:
            return {
                ...state,
                currentScreen: action.payload,
                previousScreen: ['EmmaProModal', 'SelectPremiumTierScreen'].includes(state.currentScreen || '')
                    ? state.previousScreen
                    : state.currentScreen || undefined,
            };
        case types.GET_MODAL_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                modalNotifications: __DEV__ && FORCE_SHOW_MODAL_NOTIFICATIONS
                    ? DEMO_MODAL_NOTIFICATIONS
                    : action.payload.notifications,
            };
        case types.DISMISS_MODAL_NOTIFICATIONS_SUCCESS:
        case types.CLICKED_MODAL_NOTIFICATIONS_SUCCESS:
            if (action.extra.dismissedAt) {
                return { ...state, modalNotifications: [] };
            }
            return state;
        case types.SET_COLOR_SCHEME: {
            return { ...state, colorScheme: action.payload };
        }
        case types.SET_UNHANDLED_NAVIGATE_ACTION: {
            return { ...state, failedToNavigateToScreen: action.payload };
        }
        default:
            return state;
    }
};
export default utils;
